/** Резерв под рамку (0 — фон по colorRank без обводки) */
export const CARD_BORDER_WIDTH = 0
/** Внутренний отступ рамки при ширине карты 200 (size lg) */
export const CARD_GUTTER_LG = 10
/** Высота центральной Z-полосы при ширине карты 200 */
export const CARD_STRIP_HEIGHT_LG = 100
/** Плоский зазор между верхней и нижней горизонталями Z */
export const CARD_STRIP_CENTER_GAP_LG = 60
/** Где начинается вертикальная часть Z (доля ширины слева) */
export const CARD_STEP_WIDTH_RATIO = 0.38
/** Высота pill-блоков (иконки / БС) при ширине карты 200 (size lg) */
export const CARD_PILL_HEIGHT_LG = 30
/** Ширина pill относительно высоты */
export const CARD_PILL_WIDTH_RATIO = 3.5

export interface CardShapeLayout {
  scale: number
  gutter: number
  innerW: number
  innerH: number
  stripH: number
  centerGap: number
  stepW: number
  stepX: number
  deltaY: number
  stripStart: number
  stripEnd: number
  /** Y нижнего края top слева (низ Z) */
  topBottomLeft: number
  /** Y нижнего края top справа (верх Z справа) */
  topBottomRight: number
  bottomLayerTop: number
  bottomTopLeftLocal: number
  topBlockH: number
  bottomBlockH: number
  pillHeight: number
  iconsPillWidth: number
  powerPillWidth: number
  stripIconsTop: number
  stripPowerTop: number
  bannerRadius: number
  innerRadius: number
  cardRadius: number
}

export function computeCardShapeLayout(width: number, height: number): CardShapeLayout {
  const scale = width / 200
  const gutter = CARD_GUTTER_LG * scale
  const frame = CARD_BORDER_WIDTH * 2
  const innerW = width - frame - gutter * 2
  const innerH = height - frame - gutter * 2
  const bannerRadius = Math.max(12, 14 * scale)
  const innerRadius = Math.max(10, 12 * scale)
  const minBannerH = 36 * scale

  let stripH = CARD_STRIP_HEIGHT_LG * scale
  let centerGap = CARD_STRIP_CENTER_GAP_LG * scale
  let topContentH = (innerH - stripH) / 1.7

  if (topContentH < minBannerH) {
    topContentH = minBannerH
    stripH = Math.max(14 * scale, innerH - topContentH * 2)
    centerGap = Math.min(centerGap, stripH * 0.38)
  }

  centerGap = Math.min(centerGap, stripH * 0.42)

  const stripStart = topContentH
  const stripEnd = stripStart + stripH
  const stripMid = stripStart + stripH / 2

  const topBottomLeft = stripMid - centerGap / 2
  const topBottomRight = stripMid - centerGap / 2 - (stripH - centerGap) * 0.42
  const deltaY = topBottomLeft - topBottomRight
  const bottomLayerTop = topBottomRight + centerGap
  const bottomTopLeftLocal = deltaY

  const stepW = Math.min(
    innerW * CARD_STEP_WIDTH_RATIO,
    innerW - bannerRadius * 2 - innerRadius * 2
  )

  const pillHeight = CARD_PILL_HEIGHT_LG * scale
  const iconsPillWidth = pillHeight * CARD_PILL_WIDTH_RATIO
  const powerPillWidth = pillHeight * CARD_PILL_WIDTH_RATIO

  return {
    scale,
    gutter,
    innerW,
    innerH,
    stripH,
    centerGap,
    stepW,
    stepX: stepW,
    deltaY,
    stripStart,
    stripEnd,
    topBottomLeft,
    topBottomRight,
    bottomLayerTop,
    bottomTopLeftLocal,
    topBlockH: topBottomLeft,
    bottomBlockH: innerH - bottomLayerTop,
    pillHeight,
    iconsPillWidth,
    powerPillWidth,
    stripIconsTop: topBottomRight + centerGap * 0.14,
    stripPowerTop: bottomLayerTop - pillHeight * 0.39,
    bannerRadius,
    innerRadius,
    cardRadius: Math.max(14, 18 * scale),
  }
}
